import React, {useEffect, useRef, useState} from "react";
import DataTable from 'react-data-table-component'
import {Link} from "react-router-dom";
import axios from "axios";
import {Button, Col, Form, Modal, Row, Spinner, Table} from "react-bootstrap";
import {Trash, Edit, Eye, Tool, Layers, Lock, Users} from 'react-feather';
import {authEnum, checkAuthorities, UserProfile, websetting} from "../../../helpers/websetting";
import {SystemSetting} from "../../../constants/system";
import {useTranslation} from "react-i18next";

function Roles(){
    const t = useTranslation()
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(SystemSetting.rowInPage);
    const [Organization, setOrganization] = useState([]);
    const [parent, setParent] = useState([]);

    const [show, setShow] = useState(false);
    const [info, setInfo] = useState(true);
    const [infoData, setInfoData] = useState({});

    const handleClose = () => {
        setShow(false);
        setValidated(false);
        setInfo(true);
        setLoadingModal(false)
        setInfoData({})
    }

    const handleShow = () => {
        setShow(true);
    }

    const getOrg = () => {
        axios.get(websetting.apiUrl + 'auth/api/v1/organizations/',
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setOrganization(response.data.data);
        }).catch(function (error) {
        });
    }

    const getParent = () => {
        if(UserProfile.username != "") {
            axios.get(websetting.apiUrl + 'auth/api/v1/roles/byParent',
                {
                    method: "get",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setParent(response.data);
            }).catch(function (error) {
            });
        }
    }


    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        if (form.checkValidity() === true) {
            event.preventDefault();
            setLoadingModal(true)
            const PKid = event.target.Id.value;
            if(event.target.Id.value > 0){
                axios.put(websetting.apiUrl + 'auth/api/v1/roles/'+event.target.Id.value,
                    {
                        "code": event.target.code.value,
                        "parentId": event.target.parentId.value,
                        "name": event.target.name.value,
                        "description": event.target.description.value
                    },
                    {
                        method: "put",
                        headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    const index = data.findIndex( (array) => {
                        return parseInt(array["roleIdPk"]) === parseInt(PKid)
                    });

                    let prevState = JSON.parse(JSON.stringify(data));
                    prevState[index].name = response.data.name
                    prevState[index].description = response.data.description
                    prevState[index].code = response.data.code

                    setData(prevState)
                    setShow(false)
                    setLoadingModal(true)
                }).catch(function (error) {
                    setLoadingModal(true)
                });
            }else {
                axios.post(websetting.apiUrl + 'auth/api/v1/roles/',
                    {
                        "code": event.target.code.value,
                        "parentId": event.target.parentId.value,
                        "name": event.target.name.value,
                        "organizationIdFk" : event.target.Org.value,
                        "description": event.target.description.value
                    },
                    {
                        method: "post",
                        headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    setData(data.concat(response.data))
                    setShow(false)
                    setLoadingModal(true)
                }).catch(function (error) {
                    setLoadingModal(true)
                });

            }
        }
    };

    const del = (id:any) => {
        if(window.confirm('Are you sure you wish to delete this item?')) {
            axios.delete(websetting.apiUrl + 'auth/api/v1/roles/' + id,
                {
                    method: "delete",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                const newData = data.filter((array) => {
                    return array["roleIdPk"] !== id
                });
                setData(newData)
            }).catch(function (error) {
            });
        }
    }

    const edit = (id:any) => {
        setShow(true);
        if(id > 0){
            setLoadingModal(true)

            axios.get(websetting.apiUrl + 'auth/api/v1/roles/'+id,
                {
                    method: "get",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
            }).catch(function (error) {
            });
        }
    }

    const showInfo = (id:any) => {
        setShow(true);
        setInfo(false);
        if(id > 0){
            setLoadingModal(true)
            axios.get(websetting.apiUrl + 'auth/api/v1/roles/'+id,
                {
                    method: "get",
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
            }).catch(function (error) {
            });
        }
    }

    const columns = [
        {
            name: t.t("iot.global.name"),
            selector: (row : any) => row.name,
        },{
            name: t.t("iot.global.actions"),
            cell : (row : any) => <div>{checkAuthorities(authEnum.DELETE_ROLE) && <Button variant={"outline-danger"} onClick={()=>del(row.roleIdPk)} className={"rounded-circle"}><Trash size={15} /></Button>} {checkAuthorities(authEnum.EDIT_ROLE) && <Button onClick={()=>edit(row.roleIdPk)}  variant={"outline-info"} className={"rounded-circle"}><Edit size={15} /></Button>} {checkAuthorities(authEnum.VIEW_ROLE) && <Button  variant={"outline-primary"}  onClick={()=>showInfo(row.roleIdPk)} className={"rounded-circle"}><Eye  size={15} /></Button>} {checkAuthorities(authEnum.VIEW_ROLE_PERMISSIONS) && <Link to={"../ViewRolePermission/"+row.roleIdPk} title={"View Permission"}    className={"btn  btn-success rounded-circle"}><Lock className={"mt-1"} /></Link>} {checkAuthorities(authEnum.VIEW_ROLE_USERS) &&  <Link to={"../ViewUserRoles/"+row.roleIdPk} title={"View Users"}    className={"btn btn-dark rounded-circle"}><Users className={"mt-1"} /></Link> } </div>,
        }
    ];

    const fetchDta = async (page:any) => {
        setLoading(true);
        const p = page - 1
        axios.get(websetting.apiUrl + 'auth/api/v1/roles/?pageNO='+p+'&pageSize='+SystemSetting.rowInPage,
            {
                method: "get",
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setData(response.data.data);
            setLoading(false);
            setTotalRows(response.data.recordsTotal)
        }).catch(function (error) {
            if(error != null){
                alert(error)
                setLoading(false);
            }
        });
    };

    const handlePageChange = (page :any) => {
        fetchDta(page);
    };
    const handlePerRowsChange = async (newPerPage:any, page:any) => {
        fetchDta(page)
    };

    useEffect(() => {
        getOrg()
        getParent()
        fetchDta(1); // fetch page 1 of users
    }, []);

    const infos =  JSON.parse(JSON.stringify(infoData))
    const parentInfo =  JSON.parse(JSON.stringify(parent))

    return(
        <div className={""}>
            <div className="lightbox">
                <div className={""}>
                    <div className="pagetitle text-uppercase">
                        <div className={"d-flex justify-content-between"}>
                            <div className={"d-inline-flex"}>
                                <Tool className={"feather"} size={21} />
                                {t.t("iot.global.roleTitle")}
                            </div>
                            <div className={"d-inline-flex align-content-end"}>
                                {checkAuthorities(authEnum.ADD_ROLE) &&
                                <Button   variant={"warning bold"}  onClick={()=>edit(0)}>+ {t.t("iot.global.addRole")}</Button>
                                }
                            </div>
                        </div>

                    </div>
                    {checkAuthorities(authEnum.VIEW_ROLE) &&
                    <DataTable progressPending={loading}
                               pagination
                               paginationServer
                               paginationTotalRows={totalRows}
                               progressComponent={<Spinner className={"my-5"} animation={"border"} variant={"warning"}
                                                           title={"Please Wait"}/>}
                               onChangeRowsPerPage={handlePerRowsChange}
                               onChangePage={handlePageChange} columns={columns} data={data}/>
                    }

                </div>
            </div>

            <Modal size={"lg"} centered={true}
                   show={show}
                   onExited={handleClose}
                   onHide={handleClose}
                   backdrop="static">
                <Modal.Header >
                    <Modal.Title><Tool className={"feather"} /> {t.t("iot.global.role")}</Modal.Title>
                </Modal.Header>
                <Form noValidate validated={validated}  onSubmit={handleSubmit}>
                    <Modal.Body>
                        {info ?
                            <div>{
                                loadingModal ? <div className={"text-center my-3"}><Spinner animation={"border"} variant={"danger"} /></div> :

                                    <Row>
                                        <Form.Group hidden controlId="Id" >
                                            <Form.Control type={"hidden"}   value={infos.roleIdPk}  />
                                        </Form.Group>
                                        <Col md={6}>
                                            <Form.Group className="my-2" controlId="name" >
                                                <Form.Label>{t.t("iot.global.name")}:</Form.Label>
                                                <Form.Control type="text"   defaultValue={infos.name}  required aria-label={t.t("iot.global.name")} aria-describedby="msgInput1" />
                                                <Form.Control.Feedback type="invalid"  id="msgInput1" >
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="my-2" controlId="code" >
                                                <Form.Label>{t.t("iot.global.code")}:</Form.Label>
                                                <Form.Control type="text"   defaultValue={infos.code}  required aria-label={t.t("iot.global.code")} aria-describedby="msgInput1" />
                                                <Form.Control.Feedback type="invalid"  id="msgInput1" >
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group className="my-2" controlId="parentId" >
                                                <Form.Label>{t.t("iot.global.parentID")}:</Form.Label>
                                                <Form.Select defaultValue={parentInfo.roleIdPk != null && parentInfo.roleIdPk}   aria-label={t.t("iot.global.parentID")} aria-describedby="msgInput2">
                                                    <option></option>
                                                    {Object.keys(parent).map((titles, i) => {
                                                        return(
                                                            <option selected={infos.parentId == JSON.parse(JSON.stringify(parent[i])).roleIdPk ? true : false} value={JSON.parse(JSON.stringify(parent[i])).roleIdPk} >{JSON.parse(JSON.stringify(parent[i])).name}</option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid"  id="msgInput2" >
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {!infos.roleIdPk &&
                                        <Col md={12}>
                                            <Form.Group className="my-2" controlId="Org">
                                                <Form.Label>{t.t("iot.global.organizationName")}:</Form.Label>
                                                <Form.Select required aria-label={t.t("iot.global.organizationName")}
                                                             aria-describedby="msgInput1">
                                                    {Object.keys(Organization).map((titles, i) => {
                                                        return (
                                                            <option
                                                                selected={infos.organizationIdFk == JSON.parse(JSON.stringify(Organization[i])).organizationIdPk ? true : false}
                                                                value={JSON.parse(JSON.stringify(Organization[i])).organizationIdPk}>{JSON.parse(JSON.stringify(Organization[i])).name}</option>
                                                        );
                                                    })}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid" id="msgInput1">
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        }
                                        <Col md={12}>
                                            <Form.Group className="my-2" controlId="description">
                                                <Form.Label>{t.t("iot.global.description")}:</Form.Label>
                                                <Form.Control type="text" defaultValue={infos.description}
                                                              aria-label={t.t("iot.global.description")}
                                                              aria-describedby="msgInput20"/>
                                                <Form.Control.Feedback type="invalid" id="msgInput20">
                                                    Required Field
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>

                                    </Row>
                            }
                            </div>
                            :
                            <div>
                                {
                                    loadingModal ? <div className={"text-center my-5"}><Spinner animation={"border"} variant={"danger"} /></div> :
                                        <div>
                                            <Table     hover>
                                                <tbody>
                                                <tr><td>ID</td><td>{infos.roleIdPk}</td></tr>
                                                <tr><td>{t.t("iot.global.name")}</td><td>{infos.name}</td></tr>
                                                <tr><td>{t.t("iot.global.code")}</td><td>{infos.code}</td></tr>
                                                <tr><td>{t.t("iot.global.description")}</td><td>{infos.description}</td></tr>
                                                <tr><td>{t.t("iot.global.parentID")}</td><td>{infos.parentId}</td></tr>
                                                <tr><td>{t.t("iot.global.organizationName")}</td><td>{infos.organizationDTO != null && infos.organizationDTO["name"]}</td></tr>
                                                <tr><td>{t.t("iot.global.organizationNumber")}</td><td>{infos.organizationIdFk}</td></tr>
                                                <tr><td>{t.t("iot.global.isOrganization")}</td><td>{infos.organizationIdFk === null ? "true" : "false"}</td></tr>
                                                <tr><td>{t.t("iot.global.createdBy")}</td><td>{infos.createdBy}</td></tr>
                                                <tr><td>{t.t("iot.global.createdDate")}</td><td>{infos.createDate}</td></tr>
                                                <tr><td>{t.t("iot.global.updatedBy")}</td><td>{infos.updatedBy}</td></tr>
                                                <tr><td>{t.t("iot.global.updatedDate")}</td><td>{infos.updateDate}</td></tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                }
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-dark" onClick={handleClose}>{t.t("iot.global.close")}</Button>
                        {info &&  <Button type={"submit"}  variant="warning">{t.t("iot.global.save")}</Button>}

                    </Modal.Footer>
                </Form>
            </Modal>

        </div>
    )
}
export default Roles;
